<template>
  <div class="w-full">
    <div
      @click="cancelVerification"
      class="w-full flex justify-start h-20 top-0 pl-4 md:pl-10 pt-8 fixed bg-white z-10 cursor-pointer"
    >
      <logo-icon />
    </div>
    <div class="w-full flex justify-center items-center">
      <div
        class="w-full mt-16 pt-6 flex justify-center item-center mx-2 md:w-441px"
      >
        <o-card class="w-full mx-2">
          <div class="md:p-8">
            <span
              class="flex justify-center font-bold text-2xl px-8 mx-9 text-center"
              >2 Factor Authentication
            </span>

            <div
              style="word-break: normal"
              class="flex justify-center my-4 text-center"
            >
              Enter the 6-digit code you see in authenticator app
            </div>
            <span
              class="text-grey-8 font-semibold flex justify-center text-sm my-4"
            >
              Enter 6 digit code</span
            >
            <div class="mx-4">
              <el-form
                label-position="top"
                :model="verifyAuthForm"
                ref="verifyAuthForm"
                :rules="rules"
                label-width="80px"
                size="normal"
                @submit.prevent
                @keyup.enter.native="validateForm('verifyAuthForm')"
              >
                <el-form-item prop="code" class="mb-4">
                  <el-input
                    prop="code"
                    class="text-xl"
                    v-model="verifyAuthForm.code"
                    name="code"
                    placeholder="******"
                    maxlength="6"
                    type="text"
                  ></el-input>
                </el-form-item>
                <el-form-item class="mb-4 hidden">
                  <el-input
                    class="text-xl"
                    v-model="verifyAuthForm.test"
                    name="test"
                    placeholder=""
                  ></el-input>
                </el-form-item>
                <div class="mt-6 mb-4">
                  <o-button
                    @click="validateForm('verifyAuthForm')"
                    :disabled="verifyAuthForm.code.length !== 6"
                    :loading="isLoading"
                    >{{ isLoading ? 'Verifying' : 'Verify' }}</o-button
                  >
                </div>
                <p
                  class="flex justify-center text-lg md:text-normal mt-10 cursor-pointer"
                  @click="cancelVerification"
                >
                  cancel
                </p>
              </el-form>
            </div>
          </div>
        </o-card>
      </div>
    </div>
  </div>
</template>

<script>
import logout from '@/mixins/logout.js'
import getKycDetails from '@/mixins/kyc.js'
export default {
  name: 'verifyAuthentication',
  mixins: [logout, getKycDetails],
  data () {
    return {
      isLoading: false,
      rules: {
        code: [
          {
            required: true,
            message: 'Code is required',
            trigger: ['blur', 'change']
          }
        ]
      },
      verifyAuthForm: {
        code: '',
        test: ''
      }
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  methods: {
    cancelVerification () {
      this.$router.go()
    },
    validateForm (verifyAuthForm) {
      this.$refs[verifyAuthForm].validate((valid) => {
        if (valid) {
          this.verify2fa()
        } else {
          this.$notify.error({
            title: 'Invalid Pin',
            message: 'please input a valid pin',
            position: 'top-right'
          })
        }
      })
    },
    async verify2fa () {
      const vm = this
      this.isLoading = true
      await this.$store
        .dispatch('auth/verify2fa', {
          ...this.verifyAuthForm,
          userID: this.authDetails.userID
        })
        .then((res) => {
          this.setupAfter2fa()
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getAccountActivation () {
      const vm = this
      this.$store
        .dispatch('auth/businessConfiguration')
        .then(() => {})
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
          if (error.response.data && error.response.data.code !== 401) {
            this.$router.push('system-error')
          }
        })
    },
    async setupAfter2fa () {
      const vm = this
      vm.$message({
        showClose: true,
        message: 'Verification successful',
        type: 'success'
      })
      await this.getKycDetails()
      if (
        !this.$store.state.auth.business.completedKyc &&
        !this.isManualKycType
      ) {
        this.$router.push({ name: 'accountSetup' })
      } else if (
        !this.$store.state.auth.business.completedKyc &&
        this.isManualKycType &&
        !this.kycInReview
      ) {
        this.$router.push({ name: 'submit-kyc' })
      } else {
        if (!this.kycInReview && this.accessToken) {
          await this.getAccountActivation()
        }
        this.$router.push({ name: 'dashboard' }).catch(() => {})
      }
    }
  },
  computed: {
    accessToken () {
      return this.$store.state.auth.accessToken
    },
    kycInReview () {
      return (
        this.$store.state.kyc.kycDetails?.reviewStatus ===
        this.$STATUS.PENDING_REVIEW
      )
    },
    authDetails () {
      return this.$store.state.auth.authDetails
    },
    isManualKycType () {
      return this.$store.state.auth.business.kycType === 'manual'
    }
  },
  watch: {
    'verifyAuthForm.code': function (newValue) {
      if (newValue.length !== 6) {
        const result = newValue.replace(/\D/g, '').replace(/[^0-9]/g, '')
        this.$nextTick(() => {
          this.verifyAuthForm.code = `${result}`
        })
      } else {
        this.verify2fa()
      }
    },
    deep: true
  }
}
</script>

<style scoped>
>>> .el-input__inner {
  border-radius: 8px;
  letter-spacing: 20px;
  padding-right: 3px;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  border-color: #c7c8d2;
  height: 48px;
}
</style>
